import * as React from "react";
import { JSX } from "react/jsx-runtime";

const SearchIcon = ({
  color = "#C3C3C3",
  ...props
}: JSX.IntrinsicAttributes &
  React.SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill={color}
      d="M14.802 15.864a.75.75 0 1 0 1.061-1.061l-1.06 1.06Zm-2.808-9.158a5.29 5.29 0 0 1-5.289 5.289v1.5a6.79 6.79 0 0 0 6.79-6.79h-1.5Zm-5.289 5.289a5.29 5.29 0 0 1-5.289-5.29h-1.5a6.79 6.79 0 0 0 6.79 6.79v-1.5Zm-5.289-5.29a5.29 5.29 0 0 1 5.29-5.288v-1.5a6.79 6.79 0 0 0-6.79 6.789h1.5Zm5.29-5.288a5.29 5.29 0 0 1 5.288 5.289h1.5a6.79 6.79 0 0 0-6.789-6.79v1.5Zm3.783 10.133 4.313 4.313 1.061-1.06-4.314-4.314-1.06 1.06Z"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SearchIcon;
